import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import React from "react";

import { Heading } from "~/components/ui/heading";
import { coachQueryOptions } from "~/lib/query-options";

const parentRoute = getRouteApi("/_public/discovery/$username");

export const Route = createFileRoute("/_public/discovery/$username/book/")({
  loader: async ({ context, params }) => {
    const coach = await context.queryClient.ensureQueryData(
      coachQueryOptions.byUsername(params.username),
    );
    const calendarId = coach
      ? await context.queryClient.ensureQueryData(
          coachQueryOptions.bookingCalendarId(params.username),
        )
      : null;
    return { coach, calendarId };
  },
  head: ({ loaderData }) => {
    const coach = loaderData?.coach;

    // If no coach or no calendar, emit noindex/nofollow
    if (!coach || !loaderData?.calendarId) {
      return {
        title: "Book a Call - Dream Coach Match",
        meta: [{ name: "robots", content: "noindex, nofollow" }],
      };
    }

    return {
      title: `Book a Call with ${coach.fullName} | Dream Coach Match`,
      meta: [
        {
          name: "description",
          content: `Schedule your coaching call with ${coach.fullName}`,
        },
      ],
    };
  },
  component: BookCoachPage,
});

function BookCoachPage() {
  const { coach } = parentRoute.useLoaderData();
  const { calendarId } = Route.useLoaderData();

  if (!coach) {
    return <div className="p-6">Coach not found</div>;
  }

  if (calendarId == null) {
    return <div className="p-6">Calendar not configured.</div>;
  }

  return (
    <section className="p-6">
      <Heading
        className="mb-6"
        headline={`Schedule your call with ${coach.fullName}`}
        subheadline="Pick a date and schedule your call."
      />
      <iframe
        src={`https://api.leadconnectorhq.com/widget/booking/${calendarId}`}
        style={{
          width: "100%",
          height: "750px",
          border: "none",
          borderRadius: "4px",
        }}
      />
    </section>
  );
}
